import { Pipe, PipeTransform } from "@angular/core";
import moment from 'moment';
import * as _ from 'underscore';

function compareIt(x:Object, key:string, search:any,arg?:string):boolean {
  
  var compare = x[key] //la valeur de l'object de l'array 
  
  if( _.isArray(search) ) {
    if( _.isString(compare) || _.isNumber(compare) ) {
      for(var i=0; i<search.length; i++) {
        if(search[i] === compare) return true 
      }
      return false 
    }
    else if( _.isArray(compare) ) {
      if(arg) {
        // On prend l'arg du compare 
        for(var i=0; i<search.length; i++) {
          for(var j=0; j<compare.length; j++) {
            if(compare[j][arg] === search[i]) return true 
          }
        }
        return false 
      }
      else {
        for(var i=0; i<search.length; i++) {
          if(compare.indexOf(search[i]) >= 0) return true 
        }
        return false 
      }
    }
    else return false 
  } 

  else if( _.isString(search) ) {
    if( _.isString(compare) ) return search === compare 
    else if( _.isArray(compare) ) {
      for(var i=0; i<compare.length; i++) {
        if( String(compare[i]) === search) return true 
      }
      return false 
    }
    else return false 
  }

  else if( _.isNumber(search) ) {
    if( _.isNumber(compare) ) return search === compare 
    else if( _.isArray(compare) ) {
      for(var i=0; i<compare.length; i++) {
        if( Number(compare[i]) === search) return true 
      }
      return false 
    }
    else return false 
  }
  else return false
}

@Pipe({name : "filterByObject"})
export class FilterByObject implements PipeTransform {
  transform(array: any[], obj:any, opt:string = "AND"): any[] {
    // opt peut etre égale à AND ou à OR 
    // On nettoie d'abord l'obj, on vire les array vide ou les undefined ou null ou autre truc vides pourris

    console.log(obj, opt)

    let temp = {}
    _.each(obj, (val,key) => {
      let check = false 
      if(_.isString(val) && val !== undefined && val !== null && val.length>0) {
        check = true 
      }
      else if(_.isNumber(val) && val !== NaN && val !== undefined && val !== null) {
        check = true 
      }
      else if( _.isArray(val) && val.length>0 ) {
        check = true 
      } 
      else if ( _.isBoolean(val)  && val !== undefined && val !== null ){
        console.log('ici');
        check = true;
      }
      if(check) temp[key] = val;
    })
    obj = temp 
    // console.log(obj)
    

    function doIt(item, key, search) {
      let val = item[key];  // la valeur d'un objet de l'array
      // item est un élément de array
      // key est la clé sur laquelle on cherche les match (item && search)
      // search est la valeur de comparaison avec val, soit un nombre, string, array, etc... 

      if(_.isArray(search) && search.length === 2 && _.isDate(search[0]) && _.isDate(search[1]) ) {
        let date:any = new Date(val);
        let firstDate = new Date(search[0]);
        let lastDate = new Date(search[1]);
        if ( firstDate < date && lastDate > date ){
          console.log(item.id, key, date);
          return true;
        };
      }
      // UNIQUEMENT SI C EST UN RANGE 
      else if(_.isArray(search) && search.length ===2 && _.isNumber(search[0]) && _.isNumber(search[1])) {
        if(val >= search[0] && val <= search[1]) return true;
      }
      // SI ON COMPARE AVEC PLUSIEURS STRINGS OR NUMBERS
      else if ( _.isArray(search) && search.length > 0 && _.isArray(val) ) {
        for(let i=0; i<val.length; i++ ){
          let v = val[i]
          for(let j=0; j<search.length;j++) {
            let _val = search[j];
            if( _.isString(v) && _.isString(_val) &&  _val.search(v) >= 0) return true;
            else if(_.isNumber(v) && _.isNumber(val) && +v === +_val) return true; 
            else if(_.isNumber(v) && _.isArray(val) && +v === +_val) return true; 
          }
        }
      }
      else if( _.isArray(search) && search.length > 0 && _.isNumber(val)) {
          for(let j=0; j<search.length;j++) {
            let _val = search[j]
            if(+val === +_val) {
              return true;
            }
          }

      }
      else if( _.isArray(search) && search.length > 0 && _.isString(val)) {
        for(let j=0; j<search.length;j++) {
          let _val = search[j]
          if( _.isString(_val) &&  val.search(_val) >= 0) return true;
          else if(_val === val) return true 
        }
      }
      else if(_.isNumber(search) && Number(val) === Number(search)) {
        return true;
      }
      else if(_.isString(search) && String(val) === String(search)) {
        return true;
      }
      else if ( _.isBoolean(search) && _.isBoolean(val) && search === val ){
        console.log( search, val, search === val);
        return true;
      }
      return false;
    }


    if(_.isArray(array) && array.length>0 && _.isObject(obj)) {

      array.map( (item:any) => {

        item.__match = true;

        const keys = Object.keys(obj);
        for(var i=0; i<keys.length; i++) {
          const key = keys[i];
          const search = obj[key];

          // let check = doIt(item, key, search);
          // console.log("I search", item[key], key, search, check)
          if(opt === "AND") item.__match = item.__match && doIt(item, key, search);
          if(opt === "OR") {
            item.__match = doIt(item, key, search);
            if(item.__match) break;
          }

        }

      })

      console.log(array.filter(x => x.__match ));

      return array.filter(x => x.__match );
      
      

    }
    else return array;
  }
}

@Pipe({name: "filter"})
// | filter:key:value
// item[key] strictement égale à value
// value peut etre un string, number, Array
// Si search est un array, on passe en revue les items. 
//   Il se peut cependant que les items de search ne correspondent pas directement aux items de array. 
//   arg est la clé qui permet de comparer ces deux derniers tableaux ... farfelus ... peut etre ... on verra 
export class FilterByKeyValue implements PipeTransform {
  transform(array: any[], key: string, search:any, arg?:string): any[] {
    if(!key) {
      throw "Il faut une key => filter:key:value";
    }
    else if(search === undefined || search === null) return array
    else if ( _.isString(search) && (!search || search === undefined || search === null) ) return array
    else if ( _.isNumber(search) && (search === undefined || search === null) ) return array
    else if ( (_.isString(search) || _.isArray(search)) && search.length === 0 ) return array 
    else if( (array && array.length > 0) ) {
      return array.filter( x => compareIt(x, key, search, arg) )
    } 
    else {
      return array
    }
  }
}

@Pipe({name: "searchByKey"})
// | searchByKey:key:value
// La différence avec filter est que il fait une recherche sur le contenu d'un string. (ce n'est pas ===)
export class SearchByKeyValue implements PipeTransform {
  transform(array: any[], key: string, search:string): any[] {

    if(_.isString(search) && (search.length==0 || !search || search == null)) return array

    if(!key || !search) {
      throw "Il faut une key => searchByKey:key:value";
    }

    if(array && array.length > 0) {

      var txt = String(search).toLowerCase().replace(/\s/g, '');
      if(txt.length>0) {
        var filtered = []
        array.map( (item) => {
          var value = item[key]
          if(typeof(value) == "string") {
            var val = String(value).toLowerCase().replace(/\s/g, '');
            var test = val.search(txt) >= 0
            if(test) {
              filtered.push(item)
            }
          }
        })
        return filtered
      }
      else return array
    } 
  }
}

@Pipe({name: "search"})
// | search:value:[excludedKeys]
// On fait une recherche sur le contenu string de tout l'item de l'array. 
// On peut exclure des clés sur lequels on ne veut pas faire la recherche.
export class SearchByValue implements PipeTransform {
  transform(array: any[], search:string, excludedKeys?:Array<string>): any[] {

    var excludedKeys:Array<string> = excludedKeys && excludedKeys.length>0 ? excludedKeys : []
    if(!search || search.length==0 || search == null) return array // Si on a pas de texte de recherche, alors ca ne vaut pas la peine de la faire 
    if(array && array.length > 0) { // Si on a pas un array valable, alors ca ne vaut pas la peine
      var txt = String(search).toLowerCase().replace(/\s/g, ''); // On doit comparer ce qui est comparable 
      if(txt.length>0) {
        var temp = []
        for(var i=0; i<array.length; i++) { // On passe en revue tous les item de l'array (ancien mode pour break)
          var item = array[i];
          var keys = Object.keys(item)
          for(var j=0; j<keys.length; j++) {
            var key = keys[j]
            var testKey = excludedKeys.indexOf(key) >= 0
            if(!testKey) {
              var value = item[key]
              if(typeof(value) == "string") {
                var val = String(value).toLowerCase().replace(/\s/g, ''); // On doit comparer ce qui est comparable 
                var test = val.search(txt) >= 0 // On cherche :)
                if(test) { // On trouve
                  temp.push(item)
                  break
                }
              }
            }
          }
        }
        return temp
      }
      else return array
    }
  }
}

@Pipe({name: "minDate"})
// | minDate:key:value
// key = la clé de l'objet qui définit la date minimum 
// value est la valeur de comparaison 
// Si object[key] <= minDate, on l'enleve de l'array
export class minDate implements PipeTransform {
  transform(array: any[], key:string, minDate:any): any[] {
    if(array && array.length > 0) { // Si on a pas un array valable, alors ca ne vaut pas la peine
      var mindate:any = moment(minDate)
      if(!key) {
        throw "Il faut une key => minDate:key:value";
      }
      else if(!mindate._isValid) {
        throw "minDate n'est pas valide !!!";
      }
      else {
        return array.filter( (item:any) => {
          var date:any = moment(item[key])
          return date._isValid && mindate <= date
        })
      }
    }
  }
}

@Pipe({name: "maxDate"})
// | maxDate:key:value
// key = la clé de l'objet qui définit la date minimum
// value est la valeur de comparaison
// Si object[key] >= maxDate, on l'enleve de l'array
export class maxDate implements PipeTransform {
  transform(array: any[], key:string, maxDate:any): any[] {
    if(array && array.length > 0) { // Si on a pas un array valable, alors ca ne vaut pas la peine
      var maxdate:any = moment(maxDate)
      if(!key) {
        throw "Il faut une key => maxDate:key:value";
      }
      else if(!maxdate._isValid) {
        throw "maxDate n'est pas valide !!!";
      }
      else {
        return array.filter( (item:any) => {
          var date:any = moment(item[key])
          return date._isValid && maxdate >= date
        })
      }
    }
  }
}

@Pipe({name: "find"})
// | maxDate:key:value
// key = la clé de l'objet qui définit la date minimum 
// value est la valeur de comparaison 
// Si object[key] >= maxDate, on l'enleve de l'array
export class findArrayFilter implements PipeTransform {
  transform(array: any[], key:string, value:any): any {
    if(array && array.length > 0) { // Si on a pas un array valable, alors ca ne vaut pas la peine
      return array.find( x => x[key] === value )
    }
    return array
  }
}


